<mat-toolbar>
  <span>
    <fa-icon [icon]="icon"></fa-icon> Youtube Recommender
  </span>
</mat-toolbar>
<div class="container-fluid content" role="main">
  <router-outlet></router-outlet>
</div>
